import React, { useState, useEffect } from 'react'
import { connect, useDispatch, useSelector } from "react-redux";
import { withRouter } from 'react-router-dom';
import { respostaChecklistOperacaoAction, checklistOperacaoItemAction, mensagemAction } from '../../_actions'
import { PDFViewer, Document, Page, View, Text, StyleSheet } from '@react-pdf/renderer';
import { Footer } from '../../_reports';
import { toast } from 'react-toastify'
import { history } from '../../utils'
import moment from 'moment'
import { Grid, LinearProgress } from '@material-ui/core'
import { isEmpty } from 'lodash'
import { RelatorioChecklistOperacaoProducao } from './relatorioChecklistOperacaoProducao.component';
import { RelatorioChecklistOperacaoTemperatura } from './relatorioChecklistOperacaoTemperatura.component';

const styles = StyleSheet.create({
  page: {
    padding: 20,
    paddingBottom: 25
  },
  row: {
    flexDirection: 'row',
    fontSize: 7,
    fontFamily: 'Roboto',
    borderTop: 1,
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1
  },
  rowTop: {
    flexDirection: 'row',
    fontSize: 7,
    fontFamily: 'Roboto',
    borderTop: 1,
    borderLeft: 1,
    borderRight: 1
  },
  rowBottom: {
    flexDirection: 'row',
    fontSize: 7,
    fontFamily: 'Roboto',
    borderLeft: 1,
    borderRight: 1,
    borderBottom: 1
  },
  pageHeader: {
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
  },
  instrucao: {
    fontSize: 7,
    fontFamily: 'Roboto',

    position: 'absolute',
    top: 10,
    left: 20,
    right: 25,

    paddingBottom: 15
  },
  header: {
    borderRight: 1,
    padding: 5,
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    textAlign: 'center'
  },
  cell: {
    padding: 1,
    textAlign: 'center',
    borderRight: 1,
  },
  cellLeft: {
    padding: 1,
    textAlign: 'left'
  },
  cellSmall: {
    padding: 1,
    fontSize: 6,
    textAlign: 'center',
    height: 12,
  },
  cellSmall2: {
    display: 'flex',
    textAlign: 'center',
    paddingLeft: 1,
    paddingRight: 1,
    marginLeft: 1,
    marginRight: 1
  },
  cellSpace: {
    display: 'flex',
    flexDirection: 'row',
    textAlign: 'center',
    paddingLeft: 1,
    paddingRight: 1,
    marginLeft: 1,
    marginRight: 1,
  },
  ordemProducaoPage: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  ordemProducaoHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-around',

    fontFamily: 'Roboto',
    fontWeight: 'bold',
    fontSize: 10,

    border: 1,
    padding: 5
  },
  image: {
    padding: 10,
    width: 60
  },
  title: {
    marginTop: 5,
    fontSize: 12,
    textAlign: 'center',
    fontFamily: 'Roboto',
    fontWeight: 'bold',
    flexDirection: 'row',
    width: "100%",
    alignItems: 'center',
    justifyContent: 'center'
  },
  message: {
    marginTop: 15,
    fontSize: 16,
    gap: 10,
    flexDirection: 'column',
    width: "100%",
    textAlign: 'justify'
  },
  infoTop: {
    marginTop: 5,
    fontSize: 7,
    fontFamily: 'Roboto',
    flexDirection: 'row',
    width: "100%",
    textAlign: 'justify'
  }
});

const RelatorioChecklistOperacao = (props) => {
  const dispatch = useDispatch();
  const [ready, setReady] = React.useState(false);
  const { match: { params } } = props;

  const { idLoja } = useSelector(
    (state) => state.usuarioLoja
  )

  const { checklistOperacaoItem, isLoading } = useSelector(
    (state) => state.checklistOperacaoItem
  )

  const mensagens = useSelector(
    (state) => state.mensagem.mensagem
  ) 

  const [dias, setDias] = useState([]);

  useEffect(() => {
    let filterModel = {
      Page: 0,
      Limit: 5,
      Term: '',
      Order: 'titulo',
      Direction: 'asc',
      Modulo: 2,
      IdLoja: idLoja,
      Ativos: true
    };

    dispatch(mensagemAction.getMensagem(filterModel))
  }, [idLoja]);

  useEffect(() => {

    dispatch(checklistOperacaoItemAction.clear());
    dispatch(respostaChecklistOperacaoAction.clear());

    dispatch(checklistOperacaoItemAction.isLoading());

    if (idLoja === '' || idLoja === undefined) {
      toast.error('Selecione uma Loja');
      history.push('/checklistsOperacoesCards/categorias');
    }

    const checklistsIDs = params.id.split(',').map(Number)

    let payload1 = {
      IdsChecklistOperacao: checklistsIDs,
      IdLoja: idLoja,
      DataInicial: moment(params.dataInicio).format('YYYY-MM-DD'),
      DataFinal: moment(params.dataFim).format('YYYY-MM-DD')
    };
    dispatch(checklistOperacaoItemAction.getChecklistsOperacaoItemSemana(payload1, true))

    let payload2 = {
      IdsChecklistOperacao: checklistsIDs,
      IdLoja: idLoja,
      DataInicial: moment(params.dataInicio).format('YYYY-MM-DD'),
      DataFinal: moment(params.dataFim).format('YYYY-MM-DD')
    };
    dispatch(respostaChecklistOperacaoAction.getRespostasChecklistOperacaoBySemana(payload2, true))

    var startOfWeek = moment(params.dataInicio, 'YYYY-MM-DD');
    var endOfWeek = moment(params.dataFim, 'YYYY-MM-DD');

    var day = startOfWeek;
    var days = [];

    while (day <= endOfWeek) {
      days.push(moment(day).format('YYYY-MM-DD'));
      day = moment(day).add('days', 1)
    }

    setDias(days);
  }, []);

  useEffect(() => {

    const checklistsIDs = params.id.split(',').map(Number);

    //alert(isLoading);
    if (!isLoading) {
      setTimeout(() => {
        setReady(true);
      }, (5000 + (6000 * checklistsIDs.length)));
    }
  }, [isLoading]);

  const onRendered = () => {
    //alerts.clean();
  };

  const getChecklistOperacaoName = (index) => {
    if (checklistOperacaoItem[index] && checklistOperacaoItem[index].nome) {
      return checklistOperacaoItem[index].nome
    }

    return ''
  }

  const getChecklistOperacaoInstrucao = (index) => {
    if (checklistOperacaoItem[index] && checklistOperacaoItem[index].instrucao) {
      return checklistOperacaoItem[index].instrucao
    }

    return ''
  }

  const markdownStyles = StyleSheet.create({
    bold: { fontFamily: 'Roboto', fontWeight: 'bold' },
    italic: { fontFamily: 'Roboto', fontStyle: 'italic' },
    boldItalic: { fontFamily: 'Roboto', fontWeight: 'bold', fontStyle: 'italic' },
    underline: { fontFamily: 'Roboto', textDecoration: 'underline' },
    normal: { fontFamily: 'Roboto' },
    listItem: { flexDirection: 'row', marginBottom: 4 },
    bullet: { marginRight: 6 },
  })

  function parseInline(text, keyPrefix = '') {
    const parts = []
    const regex = /(\*\*\_(.+?)\_\*\*|\_\*\*(.+?)\*\*\_|\*\*(.+?)\*\*|_(.+?)_|<u>(.+?)<\/u>)/g

    let lastIndex = 0
    let match
    let key = 0

    while ((match = regex.exec(text)) !== null) {
      const [fullMatch, , boldItalic1, boldItalic2, bold, italic, underline] = match
      const index = match.index

      if (index > lastIndex) {
        parts.push(
          <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.normal}>
            {text.slice(lastIndex, index)}
          </Text>
        )
      }

      if (boldItalic1 !== undefined) {
        parts.push(
          <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.boldItalic}>
            {boldItalic1}
          </Text>
        )
      } else if (boldItalic2 !== undefined) {
        parts.push(
          <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.boldItalic}>
            {boldItalic2}
          </Text>
        )
      } else if (bold !== undefined) {
        parts.push(
          <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.bold}>
            {bold}
          </Text>
        )
      } else if (italic !== undefined) {
        parts.push(
          <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.italic}>
            {italic}
          </Text>
        )
      } else if (underline !== undefined) {
        parts.push(
          <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.underline}>
            {underline}
          </Text>
        )
      }

      lastIndex = regex.lastIndex
    }

    if (lastIndex < text.length) {
      parts.push(
        <Text key={`${keyPrefix}-${key++}`} style={markdownStyles.normal}>
          {text.slice(lastIndex)}
        </Text>
      )
    }

    return parts
  }



  function renderPdfMarkdown(text) {
    const lines = text.trim().split('\n')
    const elements = []
    let listIndex = 1
    let key = 0

    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim()

      // Lista ordenada: "1. texto"
      const orderedMatch = line.match(/^(\d+)\.\s+(.+)/)
      if (orderedMatch) {
        const [, number, content] = orderedMatch
        elements.push(
          <View key={`ordered-${key++}`} style={markdownStyles.listItem}>
            <Text style={markdownStyles.bullet}>{number}.</Text>
            <Text>{parseInline(content, `ordered-${i}`)}</Text>
          </View>
        )
        continue
      }

      // Lista não ordenada: "- texto"
      const unorderedMatch = line.match(/^-\s+(.+)/)
      if (unorderedMatch) {
        const [, content] = unorderedMatch
        elements.push(
          <View key={`bullet-${key++}`} style={markdownStyles.listItem}>
            <Text style={markdownStyles.bullet}>•</Text>
            <Text>{parseInline(content, `bullet-${i}`)}</Text>
          </View>
        )
        continue
      }

      // Linha normal
      elements.push(
        <Text key={`text-${key++}`} style={{ marginBottom: 4 }}>
          {parseInline(line, `line-${i}`)}
        </Text>
      )
    }

    return elements
  }

  return (

    (
      (ready && !isLoading && checklistOperacaoItem != null && checklistOperacaoItem.length > 0) ?
        <PDFViewer height="100%" width="100%" >
          <Document onRender={onRendered}>
            {!isEmpty(mensagens) &&
              undefined !== mensagens &&
              mensagens.length &&
              <Page orientation="landscape" size="A4" style={styles.page} wrap={true}>
                {
                  mensagens.map((row, index) => (
                    <View style={styles.message} key={index}>
                      <Text style={{ fontFamily: 'Roboto', fontWeight: 'bold' }}>
                        {row.titulo}
                      </Text>
                      {renderPdfMarkdown(row.textoMensagem)}
                    </View>
                  ))
                }
              </Page>
            }

            {checklistOperacaoItem.map((c, i) => {
              return (
                <Page orientation="landscape" size="A4" style={styles.page} wrap={true} >

                  <View style={styles.infoTop}>
                    <Text>
                      {getChecklistOperacaoInstrucao(i) ? 'INSTRUÇÕES: ' + getChecklistOperacaoInstrucao(i) : ''}
                    </Text>
                  </View>

                  <View style={[styles.title, { textAlign: 'center' }]}>
                    <Text>{getChecklistOperacaoName(i)}</Text>
                  </View>

                  {(idLoja !== '' && idLoja !== undefined) && (
                    checklistOperacaoItem[i].tipo === 'T' ? (
                      <RelatorioChecklistOperacaoTemperatura
                        dias={dias}
                        checklistOperacaoItem={checklistOperacaoItem}
                        i={i}
                        styles={styles}
                        respostaChecklistOperacao={props.respostaChecklistOperacao}
                      />
                    ) :
                      <RelatorioChecklistOperacaoProducao
                        dias={dias}
                        checklistOperacaoItem={checklistOperacaoItem}
                        i={i}
                        styles={styles}
                        respostaChecklistOperacao={props.respostaChecklistOperacao}
                      />
                  )}

                  <Footer />
                </Page>
              )
            })}
          </Document>
        </PDFViewer>
        :
        <Grid lg={12} md={12} xl={12} xs={12}>
          <LinearProgress color="secondary" />
        </Grid>
    )
  );
}

const mapStateToProps = (state) => {
  return state;
};

const connectedRelatorioChecklistPage = withRouter(connect(mapStateToProps, null, null, {
  pure: false
})(RelatorioChecklistOperacao));
export { connectedRelatorioChecklistPage as RelatorioChecklistOperacao };
